import { DefaultPrimaryButton, DefaultSecondaryButton } from '@frontend/components/common';
import { DefaultModal, ModalType } from '@frontend/components/kiosk';
import { CommonMessage } from '@frontend/lang';
import { LuX } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

export interface OpenAllSlotsConfirmModalProps {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isOpening: boolean;
    moduleIndex: string | number;
}

export const OpenAllSlotsConfirmModal = (props: OpenAllSlotsConfirmModalProps) => {
    if (!props.show) return null;

    const handleConfirm = () => {
        props.onConfirm();
        props.onClose();
    };

    return (
        <DefaultModal
            show={props.show}
            handleClose={props.onClose}
            type={ModalType.PROMPT}
            className='m-4 w-96 overflow-hidden'>
            <div className='bg-background-surface border-border-default flex flex-col gap-6 overflow-hidden rounded-2xl border p-6'>
                <div className='flex h-6 w-full shrink-0 items-start justify-between self-stretch'>
                    <span className='text-foreground-default text-xl font-semibold'>
                        <FormattedMessage
                            id='kiosk.manage-spot.open-slots.open-all-confirm.title'
                            defaultMessage='Are you sure?'
                            description='Title for the open-all-slots confirmation modal'
                        />
                    </span>
                    <button
                        type='button'
                        className='relative size-6 cursor-pointer overflow-hidden border-0 bg-transparent p-0'
                        onClick={props.onClose}
                        aria-label='Close'
                        disabled={props.isOpening}>
                        <LuX className='text-foreground-default size-6' />
                    </button>
                </div>

                <p className='text-foreground-default font-medium'>
                    <FormattedMessage
                        id='kiosk.manage-spot.open-slots.open-all-confirm.message'
                        defaultMessage='This action will open all SLOTs for module {moduleIndex}.'
                        description='Confirmation message for opening all slots'
                        values={{ moduleIndex: props.moduleIndex }}
                    />
                </p>

                <div className='flex w-full justify-end gap-3'>
                    <DefaultSecondaryButton
                        text={CommonMessage.BUTTONS.CANCEL}
                        onClick={props.onClose}
                        disabled={props.isOpening}
                    />
                    <DefaultPrimaryButton
                        text={
                            <FormattedMessage
                                id='kiosk.manage-spot.open-slots.open-all-button'
                                defaultMessage='Open all'
                                description='Button to open all slots in current module'
                            />
                        }
                        onClick={handleConfirm}
                        disabled={props.isOpening}
                        isLoading={props.isOpening}
                    />
                </div>
            </div>
        </DefaultModal>
    );
};
